import { cn } from '@/lib/utils'

export function initiales(nom: string, repli = '?') {
  const mots = nom.trim().split(/\s+/).filter(Boolean)
  if (mots.length === 0) return repli
  const a = mots[0][0] ?? ''
  const b = mots.length > 1 ? mots[mots.length - 1][0] ?? '' : ''
  return (a + b).toUpperCase() || repli
}

interface Props {
  /** Nom complet (ou courriel en repli) : sert aux initiales. */
  nom: string
  photo?: string | null
  className?: string
}

/** Avatar d'une personne : photo si elle existe, sinon deux initiales sur gris. */
export function AvatarPersonne({ nom, photo, className }: Props) {
  if (photo) {
    return <img src={photo} alt="" className={cn('h-10 w-10 rounded-full object-cover shrink-0', className)} />
  }
  return (
    <div
      className={cn(
        'h-10 w-10 rounded-full flex items-center justify-center text-sm font-semibold shrink-0 select-none',
        'bg-slate-200 text-slate-700 dark:bg-slate-700 dark:text-slate-200',
        className,
      )}
    >
      {initiales(nom)}
    </div>
  )
}
